namespace advisorop.services {
    `use strict`;

    export class BackOfficeLinkApi {

        readonly apiUrl = `/api/backofficelink`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }
        
        calculateOrionParams(level: string, entityId: number): ng.IHttpPromise<domains.IBackOfficeOrionParams> {
            return this.$http.get(`${this.apiUrl}/calculateOrionParams?level=${level}&entityId=${entityId}`);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service("backOfficeLinkApi", BackOfficeLinkApi);
}